<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <!--
        <vs-button
          :to="`/conferences/speakers/add`"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
        <vs-button
          @click="openFilter()"
          color="primary"
          type="filled"
          class="ml-3"
          >Filter</vs-button
        >
        -->
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(filter_name)="data">
          <strong v-if="data.item.filter != null">{{
            data.item.filter.filter_name
          }}</strong>
        </template>

        <template v-slot:cell(attendee_status)="data">
          <div style="width: 120px">
            <vs-chip
              v-if="data.item.attendee_status == 'active'"
              color="success"
              >Active</vs-chip
            >
            <vs-chip
              v-else-if="data.item.attendee_status == 'removed'"
              color="danger"
              >Remove</vs-chip
            >
            <vs-chip v-else color="warning">Pending</vs-chip>
          </div>
        </template>

        <template v-slot:cell(attendee_checkin)="data">
          <div style="width: 120px">
            <vs-chip v-if="data.item.attendee_checkin == 'y'" color="success"
              >Completed</vs-chip
            >
            <vs-chip v-else color="warning">In Progress</vs-chip>
          </div>
        </template>

        attendee_type

        <template v-slot:cell(date)="data">
          <strong>{{ data.item.date }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>
    </vx-card>

    <filter-modal :list="filterList" @close="onFilterModalClose"></filter-modal>
  </div>
</template>
<script>
import Service from "@/services";

import { mapState } from "vuex";
import FilterModal from "@/components/soldoutt/FilterModal.vue";

export default {
  components: {
    FilterModal,
  },
  data: () => ({
    columns: [
      { label: "ID", key: "attendee_id", sortable: false },
      {
        label: "Attendee Status",
        key: "attendee_status",
        sortable: false,
      },
      {
        label: "Onboarding Status",
        key: "attendee_checkin",
        sortable: false,
        tdClass: "width-300",
      },
      {
        label: "Ticket",
        key: "ticket",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "First Name",
        key: "firstname",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Last Name",
        key: "lastname",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Onboarding Role",
        key: "attendee_type",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Mobile",
        key: "mobile",
        sortable: false,
        tdClass: "width-450",
      },
      {
        label: "Email",
        key: "email",
        sortable: false,
        tdClass: "width-450",
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false },
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    filterList: [],
  }),
  computed: {
    ...mapState({
      s: (state) => {
        return state.Utility.s;
      },
      e: (state) => {
        return state.Utility.e;
      },
    }),
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function (val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        Service.Attendee.gets(params)
          .then((res) => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows.map((item) => {
              return {
                ...item,
                fullname: item.speaker_firstname + " " + item.speaker_lastname,
              };
            });
            callback(this.data);
          })
          .catch((error) => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push(
        "/conferences/attendees/" +
          item.attendee_id +
          "/view?s=" +
          this.s +
          "&e=" +
          this.e
      );
    },
    openFilter() {
      this.$bvModal.show("filter-modal");
    },
    onFilterModalClose() {
      this.$bvModal.hide("filter-modal");
    },
    /*
    duplicate(item) {
      this.$router.push("/conferences/speakers/add?clone=" + item.e);
    },
    */
  },
};
</script>